import { render, staticRenderFns } from "./property_type.vue?vue&type=template&id=45425cda"
import script from "./property_type.vue?vue&type=script&lang=js"
export * from "./property_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports